var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('nav-header'),void 0],2)
}
var staticRenderFns = []

export { render, staticRenderFns }